import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  constructor(private http: HttpClient) { }

  /**
   *
   * @description Retrieves geolocation information for a given postcode string
   * from Google Maps API
   */
  geolocatePostcode(postcode: string): Observable<any> {
    return this.http.get<any>(`https://maps.googleapis.com/maps/api/geocode/json?address=${postcode}&key=${environment.googleMapsApiKey}&sensor=false&components=country:GB`);
  }
}
